import styled from 'styled-components';
import { colorGroup } from '@/styles/common';
import { flex } from '@/styles/minix';

export const PageWrap = styled.div<{ isShowBorder: boolean }>`
	height: 100%;
	overflow-y: hidden;
	min-width: 870px;
	${flex('column', 'center', 'flex-start')}
	> .page-title {
		width: 100%;
		height: 60px;
		background: #ffffff;
		box-shadow: 0px 0px 8px 0px rgba(23, 43, 77, 0.1);
		text-align: left;
		font-size: 18px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: ${colorGroup.textInferior};
		line-height: 60px;
		padding-left: 20px;
		box-sizing: border-box;
	}

	> .search--wrap,
	> .content--wrap {
		width: calc(100% - 20px);
		background: ${colorGroup.whiteColor};
		margin: 12px 10px 10px 10px;
		box-sizing: border-box;
	}

	> .content--wrap {
		${flex('column', 'center', 'flex-start')}
		flex-grow: 1;
		overflow: hidden;
		padding: 20px 20px 0 20px;
		margin-top: 0;

		> .content-title {
			width: 100%;
			font-size: 16px;
			color: ${colorGroup.textInferior};
			margin-bottom: 20px;
		}

		> .content-content {
			width: 100%;
			flex-grow: 1;
			overflow-y: auto;
			margin-bottom: 10px;
			border: ${({ isShowBorder }) => (isShowBorder ? '1px solid #DFE1E6' : 'none')};
		}

		> .pagination--wrap {
			width: 100%;
			height: 50px;
			position: relative;
		}
	}
`;
